import Vue from 'vue'
import Router from 'vue-router'

import orderTravel from '@/views/orderTravel.vue'
import recommendedRoute from '@/views/recommendedRoute.vue'
import exploreTeam from '@/views/exploreTeam.vue'
import steamerTicket from '@/views/steamerTicket.vue'
import Index from '@/views/Index/index.vue'
import RouterLists from '@/views/lists/routerLists.vue'
import freeRunning from '@/views/freeRunning.vue'
import routeDetail from '@/views/routeDetail.vue'
import SRouterLists from '@/views/lists/sRouterLists.vue'
import CustomLists from '@/views/lists/customLists.vue'
import ThemeLists from '@/views/lists/themeLists.vue'
import TeenagerLists from '@/views/lists/teenagerLists.vue'
import AllRouterLists from '@/views/lists/allRouterLists.vue'
import pastReview from '@/views/pastReview.vue'
import pastReviewDetail from '@/views/pastReviewDetail.vue'
import antarcticShipBooking from '@/views/antarcticShipBooking.vue'
import arcticShipBooking from '@/views/arcticShipBooking.vue'
import club from '@/views/club.vue'
import news from '@/views/news.vue'
import about from '@/views/about.vue'
import contactUs from '@/views/contactUs.vue'
import partners from '@/views/partners.vue'
import freeTravel from '@/views/freeTravel.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: {
        name: 'Index'
      }
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/orderTravel', // 订制旅行
      name: 'orderTravel',
      component: orderTravel
    },
    {
      path: '/recommendedRoute', // 订制旅行推荐路线
      name: 'recommendedRoute',
      component: recommendedRoute
    },
    {
      path: '/teacher', // 极地探险队
      name: 'exploreTeam',
      component: exploreTeam
    },
    {
      path: '/steamerTicket', // 船票详情
      name: 'steamerTicket',
      component: steamerTicket
    },
    {
      path: '/free', // 自由行宫略
      name: 'freeRunning',
      component: freeRunning
    },
    {
      path: '/routeDetail', // 路线详情
      name: 'routeDetail',
      component: routeDetail
    },
    {
      path: '/routerLists', // 北极路线
      name: 'RouterLists',
      component: RouterLists
    },
    {
      path: '/sRouterLists', // 南极路线
      name: 'SRouterLists',
      component: SRouterLists
    },
    {
      path: '/CustomLists', // 订制旅行推荐路线
      name: 'CustomLists',
      component: CustomLists
    },
    {
      path: '/themeLists', // 主题旅行
      name: 'ThemeLists',
      component: ThemeLists
    },
    {
      path: '/teenagerLists', // 青少年研学
      name: 'TeenagerLists',
      component: TeenagerLists
    },
    {
      path: '/allRouterLists', // 所有路线
      name: 'AllRouterLists',
      component: AllRouterLists
    },
    {
      path: '/pastReview', // 往期回顾
      name: 'PastReview',
      component: pastReview
    },
    {
      path: '/pastReviewDetail', // 忘情回顾详情/自由行详情
      name: 'PastReviewDetail',
      component: pastReviewDetail
    },
    {
      path: '/arcticShipBooking', // 北极船票预定
      name: 'ArcticShipBooking',
      component: arcticShipBooking
    },
    {
      path: '/antarcticShipBooking', // 南极船票预定
      name: 'AntarcticShipBooking',
      component: antarcticShipBooking
    },
    {
      path: '/club', // 俱乐部
      name: 'Club',
      component: club
    },
    {
      path: '/news', // 极之美资讯
      name: 'News',
      component: news
    },
    {
      path: '/about', // 公司介绍
      name: 'About',
      component: about
    },
    {
      path: '/contactUs', // 联系我们
      name: 'ContactUs',
      component: contactUs
    },
    {
      path: '/partners', // 合作伙伴
      name: 'Partners',
      component: partners
    },
    {
      path: '/freeTravel', // 合作伙伴
      name: 'freeTravel',
      component: freeTravel
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js